import { useMutation } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { api } from '../api';
import { errorText, useI18n } from '../i18n';
import { Alert, AuthCard } from '../layout';

/** The page the confirmation e-mail opens: confirming takes a click, so mail scanners opening links do not confirm. */
export function ConfirmSenderPage({ token }: { token: string }) {
  const { t } = useI18n();
  const confirm = useMutation({ mutationFn: () => api.post<{ email: string }>('api/v1/inbox/senders/confirm', { token }) });
  return (
    <AuthCard eyebrow="FakturaSmart Pro" title={t('Adreso patvirtinimas')} intro={t('Patvirtinkite, kad iš šio adreso siunčiamos sąskaitos turi patekti į įmonės FakturaSmart Pro paskyrą.')}
      footer={<Link to="/login">{t('Prisijungti')}</Link>}>
      {confirm.isSuccess ? <Alert kind="success">{t('Adresas {email} patvirtintas. Iš jo siųstos sąskaitos bus priimamos.', { email: confirm.data.email })}</Alert> : null}
      {confirm.isError ? <Alert kind="error">{errorText(t, confirm.error)}</Alert> : null}
      {!confirm.isSuccess ? <button type="button" className="button button--primary" disabled={confirm.isPending || !token} onClick={() => confirm.mutate()}>{t('Patvirtinti adresą')}</button> : null}
    </AuthCard>
  );
}
